// Booking flow endpoints
export const PACKAGE_SESSION_SHOW = `${import.meta.env.VITE_API_HOST}/package/session/:sessionId`;
export const PACKAGE_SESSION_STORE = `${import.meta.env.VITE_API_HOST}/package/session`;
export const PACKAGE_INFORMATION = `${import.meta.env.VITE_API_HOST}/information`;
export const PACKAGE_CONFIRMATION = `${import.meta.env.VITE_API_HOST}/package/confirmation`;
export const PACKAGE_CALENDAR_PRICES = `${import.meta.env.VITE_API_HOST}/package/:packageId/calendar`;
export const PACKAGE_PERIOD = `${import.meta.env.VITE_API_HOST}/package/:packageId/period`;
export const BOOKING_CONTACT = `${import.meta.env.VITE_API_HOST}/calendar-contact`;
export const PACKAGE_SESSION_SAVE = `${import.meta.env.VITE_API_HOST}/package/session/save`;
export const PACKAGE_SESSION_QUOTATION = `${import.meta.env.VITE_API_HOST}/package/session/quotation`;
export const PROMO_CODE = `${import.meta.env.VITE_API_HOST}/promo-code/verify`;

// My environment endpoints
export const LOGIN = `${import.meta.env.VITE_API_HOST}/login`;
export const CUSTOMER_TRAVELPLANS = `${import.meta.env.VITE_API_HOST}/customer-travelplan`;
export const CUSTOMER_TRAVELPLAN = `${import.meta.env.VITE_API_HOST}/customer-travelplan/:travelplanId`;
export const CUSTOMER_TRAVELPLAN_FILES = `${import.meta.env.VITE_API_HOST}/customer-travelplan/:travelplanId/files`;
